export const codeList = {
  //台灣銀行代碼與名稱（資料來源：https://github.com/wsmwason/taiwan-bank-code）
  BankCodes: [
    { value: "004", label: "臺灣銀行" },
    { value: "005", label: "臺灣土地銀行" },
    { value: "006", label: "合作金庫商業銀行" },
    { value: "007", label: "第一商業銀行" },
    { value: "008", label: "華南商業銀行" },
    { value: "009", label: "彰化商業銀行" },
    { value: "011", label: "上海商業儲蓄銀行" },
    { value: "012", label: "台北富邦商業銀行" },
    { value: "013", label: "國泰世華商業銀行" },
    { value: "016", label: "高雄銀行" },
    { value: "017", label: "兆豐國際商業銀行" },
    { value: "021", label: "花旗(台灣)商業銀行" },
    { value: "050", label: "臺灣中小企業銀行" },
    { value: "052", label: "渣打國際商業銀行" },
    { value: "053", label: "台中商業銀行" },
    { value: "054", label: "京城商業銀行" },
    { value: "101", label: "瑞興商業銀行" },
    { value: "102", label: "華泰商業銀行" },
    { value: "103", label: "臺灣新光商業銀行" },
    { value: "108", label: "陽信商業銀行" },
    { value: "114", label: "基隆第一信用合作社" },
    { value: "115", label: "基隆市第二信用合作社" },
    { value: "118", label: "板信商業銀行" },
    { value: "119", label: "淡水第一信用合作社" },
    { value: "130", label: "新竹第一信用合作社" },
    { value: "132", label: "新竹第三信用合作社" },
    { value: "146", label: "台中市第二信用合作社" },
    { value: "147", label: "三信商業銀行" },
    { value: "162", label: "彰化第六信用合作社" },
    { value: "165", label: "彰化縣鹿港信用合作社" },
    { value: "215", label: "花蓮第一信用合作社" },
    { value: "216", label: "花蓮第二信用合作社" },
    { value: "600", label: "財團法人全國農漁業及金融資訊中心" },
    { value: "700", label: "中華郵政股份有限公司" },
    { value: "803", label: "聯邦商業銀行" },
    { value: "805", label: "遠東國際商業銀行" },
    { value: "806", label: "元大商業銀行" },
    { value: "807", label: "永豐商業銀行" },
    { value: "808", label: "玉山商業銀行" },
    { value: "809", label: "凱基商業銀行" },
    { value: "812", label: "台新國際商業銀行" },
    { value: "815", label: "日盛國際商業銀行" },
    { value: "816", label: "安泰商業銀行" },
    { value: "822", label: "中國信託商業銀行" },
    { value: "910", label: "財團法人農漁會聯合資訊中心" },
    { value: "928", label: "板橋區農會電腦共用中心" },
    { value: "951", label: "新北市農會附設北區農會電腦共同利用中心" },
    { value: "952", label: "財團法人農漁會南區資訊中心" },
    { value: "997", label: "中華民國信用合作社聯合社南區聯合資訊處理中心" }
  ]
};
